// src/utils/api.ts
// Central fetch wrapper — attaches Firebase ID token and routes through the dev proxy.
// Use this instead of fetch() for all API calls.

import { auth } from '../firebase';

const API_BASE = process.env.NODE_ENV === 'development' ? '' : (process.env.REACT_APP_API_URL || '');

export { API_BASE };

export async function apiFetch(path: string, options: RequestInit = {}): Promise<Response> {
    const url = path.startsWith('http') ? path : `${API_BASE}${path}`;
    const method = (options.method || 'GET').toUpperCase();
    const hasBody = method !== 'GET' && method !== 'HEAD';

    // Attach Firebase ID token when the user is signed in
    const authHeaders: Record<string, string> = {};
    try {
        const user = auth.currentUser;
        if (user) {
            const token = await user.getIdToken();
            authHeaders['Authorization'] = `Bearer ${token}`;
        }
    } catch (_) { /* non-fatal — public endpoints don't require a token */ }

    return fetch(url, {
        ...options,
        headers: {
            'Accept': 'application/json',
            ...(hasBody ? { 'Content-Type': 'application/json' } : {}),
            ...authHeaders,
            ...(options.headers || {}),
        },
    });
}

// Convenience wrappers
export async function apiGet(path: string): Promise<any> {
    const res = await apiFetch(path);
    if (!res.ok) throw new Error(`GET ${path} failed: ${res.status}`);
    return res.json();
}

export async function apiPost(path: string, body: any): Promise<any> {
    const res = await apiFetch(path, {
        method: 'POST',
        body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`POST ${path} failed: ${res.status}`);
    return res.json();
}
